import { gql } from 'graphql-request';

/**
 * Returns a ProductVariant
 */
export const PRODUCT_VARIANT = gql`
  query getProductVariant($productVariantId: ID!) {
    node(id: $productVariantId) {
      ... on ProductVariant {
        title
        priceV2 {
          amount
          currencyCode
        }
        product {
          id
          title
          productType
          tags
        }
      }
    }
  }
`;

export default {};
